import { render } from "./MyPageReviewDoneNotice.vue?vue&type=template&id=020c38cd"
import script from "./MyPageReviewDoneNotice.vue?vue&type=script&lang=js"
export * from "./MyPageReviewDoneNotice.vue?vue&type=script&lang=js"

import "./MyPageReviewDoneNotice.vue?vue&type=style&index=0&id=020c38cd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__